import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Globals } from '../../globals';
import { Country } from './countries.interfaces';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  private readonly translateService = inject(TranslateService);


  /**
   * Get all Countries
   */
  getCountries(language: number): Observable<Country[]> {
    const url = `${this.globals.apiRoot}/jwtcountries/${language}`;
    return this.http.get<Country[]>(url).pipe(timeout(1000));
  }

  getCountriesForCurrentLanguage(): Observable<Country[]> {
    return this.getCountries(this.getCurrentLanguage());
  }

  /***
   * Get currently used (or a default) language
   */
  private getCurrentLanguage(): number {
    // find active language
    let currentLang = 1; // set 1 as default

    // if a currentlang was set in the translate service; language should be formatted as e.g.: 'client_1', 'public_3'
    if (
      this.translateService.currentLang !== undefined &&
      this.translateService.currentLang !== null &&
      this.translateService.currentLang.split('_').length === 2
    ) {
      const cLang = Number(this.translateService.currentLang.split('_')[1]);
      if (!isNaN(cLang)) {
        currentLang = cLang;
      }
    } else {
      // if the defaultlang was set in the translate service; language should be formatted as e.g.: 'client_1', 'public_3'
      if (
        this.translateService.defaultLang !== undefined &&
        this.translateService.defaultLang !== null &&
        this.translateService.defaultLang.split('_').length === 2
      ) {
        const cLang = Number(this.translateService.defaultLang.split('_')[1]);
        if (!isNaN(cLang)) {
          currentLang = cLang;
        }
      }
    }

    return currentLang;
  }
}
